(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["service-embroidery"] && !Shopify.designMode) return;
  try {
    
  function filterCards(tag, btn) {
    document.querySelectorAll('.svc-filter').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.svc-card').forEach(function(card){
      var tags = card.dataset.tags || '';
      card.style.display = (tag === 'all' || tags.includes(tag)) ? '' : 'none';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-engraving"] && !Shopify.designMode) return;
  try {
    
  function filterCards(tag, btn) {
    document.querySelectorAll('.svc-filter').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.svc-card').forEach(function(card){
      var tags = card.dataset.tags || '';
      card.style.display = (tag === 'all' || tags.includes(tag)) ? '' : 'none';
    });
  }

  var PEN_STYLES = {
    metal:  { barrel: '#8C8C8C', tip: '#6E6E6E', clip: '#AAAAAA', endcap: '#777', shine: 'rgba(255,255,255,0.18)', text: 'rgba(30,30,30,0.9)' },
    black:  { barrel: '#1A1A1A', tip: '#111',    clip: '#888',    endcap: '#333', shine: 'rgba(255,255,255,0.06)', text: 'rgba(255,255,255,0.85)' },
    bamboo: { barrel: '#C8A15A', tip: '#9E7A3A', clip: '#B08A48', endcap: '#A07840', shine: 'rgba(255,255,255,0.12)', text: 'rgba(60,30,0,0.85)' },
    blue:   { barrel: '#365F73', tip: '#274455', clip: '#4A7A90', endcap: '#2C5063', shine: 'rgba(255,255,255,0.12)', text: 'rgba(255,255,255,0.9)' },
  };
  var currentPenStyle = 'black';

  function setPenStyle(style, btn) {
    currentPenStyle = style;
    document.querySelectorAll('.pen-style').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    updatePenPreview();
  }

  function updatePenPreview() {
    var s = PEN_STYLES[currentPenStyle];
    var barrel  = document.getElementById('pen-barrel');
    var tip     = document.getElementById('pen-tip');
    var clip    = document.getElementById('pen-clip-body');
    var clipEnd = document.getElementById('pen-clip-end');
    var endcap  = document.getElementById('pen-endcap');
    var textEl  = document.getElementById('pen-engrave-text');
    if (!barrel) return;

    barrel.setAttribute('fill', s.barrel);
    tip.setAttribute('fill', s.tip);
    clip.setAttribute('fill', s.clip);
    clipEnd.setAttribute('fill', s.clip);
    endcap.setAttribute('fill', s.endcap);
    textEl.setAttribute('fill', s.text);

    var line1 = document.getElementById('pen-line1').value || 'YOUR TEXT HERE';
    var line2 = document.getElementById('pen-line2').value || '';

    if (line2) {
      textEl.setAttribute('y', '55');
      textEl.setAttribute('font-size', '16');
      textEl.textContent = line1;

      var line2El = document.getElementById('pen-engrave-text2');
      if (!line2El) {
        line2El = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        line2El.setAttribute('id', 'pen-engrave-text2');
        line2El.setAttribute('x', '230');
        line2El.setAttribute('text-anchor', 'middle');
        line2El.setAttribute('dominant-baseline', 'middle');
        line2El.setAttribute('font-family', 'Georgia, serif');
        line2El.setAttribute('letter-spacing', '2');
        document.getElementById('pen-svg').appendChild(line2El);
      }
      line2El.setAttribute('y', '75');
      line2El.setAttribute('font-size', '13');
      line2El.setAttribute('fill', s.text);
      line2El.textContent = line2;
    } else {
      textEl.setAttribute('y', '67');
      textEl.setAttribute('font-size', '20');
      textEl.textContent = line1;
      var old = document.getElementById('pen-engrave-text2');
      if (old) old.textContent = '';
    }
  }

  function scrollToPenQuote() {
    var line1 = document.getElementById('pen-line1').value;
    var line2 = document.getElementById('pen-line2').value;
    var qty   = document.getElementById('pen-qty').value;
    document.getElementById('pen-form-config').value = 'Style: ' + currentPenStyle + ' | Line 1: ' + line1 + ' | Line 2: ' + line2 + ' | Qty: ' + qty;
    document.getElementById('pen-quote').scrollIntoView({behavior:'smooth', block:'start'});
  }

  updatePenPreview();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-patches"] && !Shopify.designMode) return;
  try {
    
  function filterCards(tag, btn) {
    document.querySelectorAll('.svc-filter').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.svc-card').forEach(function(card){
      var tags = card.dataset.tags || '';
      card.style.display = (tag === 'all' || tags.includes(tag)) ? '' : 'none';
    });
  }
  function scrollToPatchBuilder() {
    document.getElementById('patch-builder').scrollIntoView({behavior:'smooth',block:'start'});
  }
  function scrollToPatchQuote() {
    document.getElementById('patch-form-config').value = buildPatchConfig();
    document.getElementById('patch-quote').scrollIntoView({behavior:'smooth',block:'start'});
  }
  function buildPatchConfig() {
    var ptype = document.querySelector('input[name="ptype"]:checked');
    var backing = document.querySelector('input[name="pbacking"]:checked');
    return 'Type: ' + (ptype ? ptype.value : '') + ' | Backing: ' + (backing ? backing.value : '') + ' | Line 1: ' + (document.getElementById('patch-line1').value) + ' | Line 2: ' + (document.getElementById('patch-line2').value);
  }

  var patchBg = '#1B2A4A';
  var patchText = '#FFFFFF';
  var patchShape = 'rect';

  var BG_COLORS = [
    {name:'Navy', hex:'#1B2A4A'},{name:'Black', hex:'#111111'},{name:'OD Green', hex:'#4B5320'},
    {name:'Coyote', hex:'#81613C'},{name:'Ranger Green', hex:'#3B4A3F'},{name:'Brown', hex:'#6B4F35'},
    {name:'Red', hex:'#CC2200'},{name:'Maroon', hex:'#7A1C1C'},{name:'Royal Blue', hex:'#2255CC'},
    {name:'Grey', hex:'#808080'},{name:'Khaki', hex:'#C8A97A'},{name:'White', hex:'#F5F5F5'},
  ];
  var TEXT_COLORS = [
    {name:'White', hex:'#FFFFFF'},{name:'Black', hex:'#111111'},{name:'Yellow', hex:'#F5C518'},
    {name:'Gold', hex:'#D4A017'},{name:'Red', hex:'#CC2200'},{name:'Silver', hex:'#C0C0C0'},
    {name:'HiVis', hex:'#39FF14'},
  ];

  function buildSwatches(colors, containerId, type) {
    var container = document.getElementById(containerId);
    if (!container) return;
    colors.forEach(function(c, i) {
      var s = document.createElement('div');
      s.className = 'patch-swatch' + (i === 0 ? ' active' : '');
      s.style.background = c.hex;
      s.title = c.name;
      if (c.hex === '#F5F5F5') s.style.border = '2px solid #CCC';
      s.onclick = function() {
        container.querySelectorAll('.patch-swatch').forEach(function(x){ x.classList.remove('active'); });
        s.classList.add('active');
        if (type === 'bg') patchBg = c.hex;
        else patchText = c.hex;
        updatePatchPreview();
      };
      container.appendChild(s);
    });
  }

  buildSwatches(BG_COLORS, 'bg-swatches', 'bg');
  buildSwatches(TEXT_COLORS, 'text-swatches', 'text');

  var SHAPES = {
    rect:  {w:304, h:144, rx:10,  label:'Rectangular'},
    tab:   {w:304, h:88,  rx:44,  label:'Name Tab'},
    shield:{w:240, h:144, rx:0,   label:'Shield'},
    round: {w:144, h:144, rx:72,  label:'Round'},
  };

  function setPatchShape(shape, btn) {
    patchShape = shape;
    document.querySelectorAll('.patch-shape').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    updatePatchPreview();
  }

  function updatePatchPreview() {
    var s = SHAPES[patchShape];
    var bg  = document.getElementById('patch-bg');
    var brd = document.getElementById('patch-border');
    var t1  = document.getElementById('patch-text1');
    var t2  = document.getElementById('patch-text2');
    if (!bg) return;
    var line1 = document.getElementById('patch-line1').value || 'YOUR TEXT';
    var line2 = document.getElementById('patch-line2').value || '';
    var x = (320 - s.w) / 2;
    var y = (160 - s.h) / 2;
    [bg, brd].forEach(function(el) {
      el.setAttribute('x', x); el.setAttribute('y', y);
      el.setAttribute('width', s.w); el.setAttribute('height', s.h);
      el.setAttribute('rx', s.rx);
    });
    bg.setAttribute('fill', patchBg);
    t1.setAttribute('fill', patchText);
    t2.setAttribute('fill', patchText);
    t1.textContent = line1.toUpperCase();
    t2.textContent = line2.toUpperCase();
    var cy = line2 ? 74 : 80;
    t1.setAttribute('y', cy);
    t1.setAttribute('font-size', line1.length > 12 ? '20' : '26');
    t2.setAttribute('y', cy + 32);
    t2.setAttribute('font-size', '14');
  }

  function updatePatchDims(val) {
    var map = {'4x2':'4" × 2"','3x2':'3" × 2"','5x3':'5" × 3"','3.5x1':'3.5" × 1"','2x2':'2" × 2"','custom':'Custom Size'};
    document.getElementById('preview-dims').textContent = 'Size: ' + (map[val] || val) + ' · ' + (SHAPES[patchShape] ? SHAPES[patchShape].label : '');
  }

  updatePatchPreview();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-printing"] && !Shopify.designMode) return;
  try {
    
  function filterCards(tag, btn) {
    document.querySelectorAll('.svc-filter').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.svc-card').forEach(function(card){
      var tags = card.dataset.tags || '';
      var hide = tag !== 'all' && !tags.includes(tag);
      card.style.display = hide ? 'none' : '';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-signage"] && !Shopify.designMode) return;
  try {
    
  function filterCards(tag, btn) {
    document.querySelectorAll('.svc-filter').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.svc-card').forEach(function(card){
      var tags = card.dataset.tags || '';
      card.style.display = (tag === 'all' || tags.includes(tag)) ? '' : 'none';
    });
  }

  } catch(e) { console.error(e); }
})();
})();
